import iconUrl from "../../src-tauri/icons/32x32.png";
import { isTauriSync } from "../lib/tauri";

async function win() {
  const { getCurrentWindow } = await import("@tauri-apps/api/window");
  return getCurrentWindow();
}

async function minimize() {
  try {
    (await win()).minimize();
  } catch {
    /* dev-browser */
  }
}
async function toggleMaximize() {
  try {
    (await win()).toggleMaximize();
  } catch {
    /* */
  }
}
async function close() {
  try {
    // Triggert de CloseRequested-handler in lib.rs → verbergt naar tray.
    (await win()).close();
  } catch {
    /* */
  }
}

export default function TitleBar() {
  // In een gewone browser (PWA-mode) heeft de WebView z'n eigen chrome —
  // onze custom titlebar zou alleen ruimte stelen en de drag-region
  // doet daar niets.
  if (!isTauriSync()) return null;
  return (
    <div
      data-tauri-drag-region
      className="flex h-8 shrink-0 select-none items-center justify-between bg-slate-900 pl-2 text-slate-300"
    >
      <div data-tauri-drag-region className="flex items-center gap-2">
        <img src={iconUrl} alt="" className="h-4 w-4" draggable={false} />
        <span data-tauri-drag-region className="text-xs font-medium tracking-wide text-slate-400">
          Swift
        </span>
      </div>
      <div className="flex">
        <button
          onClick={() => void minimize()}
          className="flex h-8 w-11 items-center justify-center text-slate-400 hover:bg-slate-700 hover:text-slate-100"
          title="Minimaliseren"
          aria-label="Minimaliseren"
        >
          <svg width="10" height="10" viewBox="0 0 10 10">
            <rect x="0" y="4.5" width="10" height="1" fill="currentColor" />
          </svg>
        </button>
        <button
          onClick={() => void toggleMaximize()}
          className="flex h-8 w-11 items-center justify-center text-slate-400 hover:bg-slate-700 hover:text-slate-100"
          title="Maximaliseren"
          aria-label="Maximaliseren"
        >
          <svg width="10" height="10" viewBox="0 0 10 10">
            <rect x="0.5" y="0.5" width="9" height="9" fill="none" stroke="currentColor" />
          </svg>
        </button>
        <button
          onClick={() => void close()}
          className="flex h-8 w-11 items-center justify-center text-slate-400 hover:bg-red-600 hover:text-white"
          title="Sluiten"
          aria-label="Sluiten"
        >
          <svg width="10" height="10" viewBox="0 0 10 10">
            <path d="M0 0 L10 10 M10 0 L0 10" stroke="currentColor" strokeWidth="1" />
          </svg>
        </button>
      </div>
    </div>
  );
}
